import styled from 'styled-components'

import { InputGroup } from 'client/components/InputReadOnly/styles'
import { AgeSelectorBase } from 'src/comps/AgeSelector/styles'
import { colors, media } from 'client/styles'

export const CheckAvailabilityBase = styled.div`
  background: ${colors.white};
  padding-block: 0 30px;
  padding-inline: 20px;
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  width: 100%;
  border-radius: 8px;

  & > button {
    min-width: 200px;
    span svg {
      animation: spin 1s linear infinite;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }

  ${media.tablet} {
    flex-direction: column-reverse;

    & > button {
      order: 1;
      align-self: end;
    }
  }
`

export const ModifyDatesAndGuests = styled.div`
  ${media.tablet} {
    order: 2;
  }
`

export const Row = styled.div`
  display: flex;
  width: 100%;

  padding-block: 15px;
  padding-inline: 0;
`

export const LeftRow = styled.div`
  display: flex;
  flex-wrap: wrap;

  padding-block-end: 15px;
  ${AgeSelectorBase} {
    max-width: unset;
  }
`

export const DateSelectorBase = styled.div`
  width: 100%;
  margin-block-end: 16px;

  ${media.tablet} {
    margin-block-end: 0;
  }
`

export const Content = styled.div`
  align-items: center;
  background-color: ${colors.white};
  border-radius: 8px;
  border: 2px solid;
  border-color: ${props => (props.isFocus ? colors.grey1 : colors.grey4)};
  display: flex;
  justify-content: space-between;
  position: relative;

  ${props =>
    props.type === 'inline' &&
    `
      flex: 0 0 auto;
      margin-inline-end: .75em;
      width: 300px;
      padding-block: 0;
      padding-inline: 1rem;
  `};

  .datepicker-default {
    position: absolute;
    inset-block-start: calc(100% + 10px);
    inset-inline-start: 0;
    z-index: 11;
  }

  ${InputGroup} {
    background-color: transparent;
    padding-block: 9px;
    padding-inline: 9px;

    :first-of-type {
      border-inline-end: 2px solid ${colors.grey4};
    }
  }
`

export const PaxWrapper = styled.div`
  width: 100%;
`

export const ItemSelector = styled.div`
  padding-block-end: 20px;
`

export const AgeRange = styled.span`
  display: block;
  font-size: 12px;
  line-height: 1.4;
  color: ${colors.grey2};
`

export const ChildrenAge = styled.div`
  width: 100px;
  padding-inline-end: 20px;
`

export const Title = styled(Row)`
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;
  color: ${colors.grey1};
  padding-block: 0 16px;
  padding-inline: 0;
`

export const SubTitle = styled(Row)`
  display: flex;

  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  padding-block: 0;
  padding-inline: 0;

  color: ${colors.grey2};

  ${media.tablet} {
    height: 28px;
  }
`
